// M004-F0810 / T-M004-0477: preserve the canonical source value while
// recognizing the one linked legacy shape that Core still returns for a
// Google Calendar booking.
export const isCalendarGuestIdentityEligible = (booking) => Boolean(booking && (
  booking.source === 'google_calendar'
  || (booking.source === 'studioaeye'
    && booking.owner_source === 'gcal_booked_by'
    && typeof booking.google_event_id === 'string'
    && booking.google_event_id.trim() !== '')
));
